import React, { useMemo } from 'react'
import { theme } from '../../theme/theme'
import { cn } from '../../helpers/utils'
import { Badge } from '../common/Badge/Badge'

export const PillButton = ({
  title,
  onClick,
  active,
  notificationCount,
}: {
  title: string
  onClick: () => void
  active?: boolean
  notificationCount?: number
}): React.ReactNode => {
  const count = useMemo(() => {
    if (!notificationCount) return undefined
    if (notificationCount > 9) {
      return '9+'
    }
    return String(notificationCount)
  }, [notificationCount])
  return (
    <button onClick={onClick}>
      <span
        style={theme.textVariants.baseBold}
        className={cn(
          'flex items-center rounded-full text-center leading-none px-3 py-1',
          active ? 'bg-brandGreen' : 'bg-white',
          active ? 'text-white' : 'text-black'
        )}
      >
        {title}
        {!!count && (
          <Badge
            className="ml-2"
            text={count}
            colorClass={active ? 'bg-white' : 'bg-brandGreen'}
            textColorClass={active ? 'text-brandGreen' : 'text-white'}
          />
        )}
      </span>
    </button>
  )
}
